import { Inject, Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { Router } from '@angular/router';
import { catchError, last, map, tap } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { LoadingService } from './_common/services/loading.service';
import { DEFAULT_LANGUAGE, ROUTE_ACCESS_DENIED } from './_common/constants';
import { AuthService } from './auth/auth.service';

@Injectable()
export class AppHttpInterceptor implements HttpInterceptor {

    constructor(
        private router: Router,
        private loading: LoadingService,
        private translateService: TranslateService,
        private authService: AuthService,
        @Inject('API_URL') private apiUrl: string) { };

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
                
        this.loading.setLoading(true, request.url);

        request = request.clone({
            withCredentials: true,
            headers: request.headers.set('Accept-Language',this.translateService.currentLang || DEFAULT_LANGUAGE),
        });

        return next.handle(request)
            .pipe(
                last(),
                tap(event => {
                    if (event instanceof HttpResponse) {
                    }
                }),
                catchError((err: any) => {
                    this.loading.setLoading(false, request.url)
                    if (err instanceof HttpErrorResponse) {
                        if (err.status === 401){
                            this.router.navigate([ROUTE_ACCESS_DENIED])
                            return of(err);
                        }
                    }
                    return of(err);
                }))
            .pipe(map<HttpEvent<any>, any>((evt: HttpEvent<any>) => {
                if (evt instanceof HttpResponse) {
                    this.loading.setLoading(false, request.url);
                }
                return evt;
            }));
        }
}
